import { Box, Stack } from '@mui/material';

import HeaderLegacy from '../header/HeaderLegacy';
import { IPageProps } from '../LayoutPreference/layoutTypes';

/** @deprecated Temporary dual-layout rollout legacy page shell. Remove when legacy layout is retired. */
export default function PageWithHeaderLegacy({
  children,
  tabs,
  title,
}: IPageProps & { children: React.ReactNode }): React.ReactElement {
  return (
    <Stack sx={{ height: '100%' }}>
      <HeaderLegacy title={title} tabs={tabs} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-center',
          flex: 1,
          m: 2,
        }}
      >
        {children}
      </Box>
    </Stack>
  );
}
